import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
// import { format, utcToZonedTime, } from "date-fns-tz";

import { scrollToTop } from "../common/Header/helper";
import { Icon } from "../../globals/icons";
import { StyledDesc1, StyledDesc2, StyledDesc3, StyledDescTag } from "../shared/StyledTypography";
import { COLORS } from "../../globals/designSystem";
import { mq } from "../../globals/utils";
import { flexCenter } from "../shared/CommonStyled";

function UsersIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3077 13.6539V12.4231C10.3077 11.7702 10.0889 11.1441 9.69938 10.6825C9.30988 10.2209 8.7816 9.96155 8.23077 9.96155H4.07692C3.52609 9.96155 2.99782 10.2209 2.60832 10.6825C2.21882 11.1441 2 11.7702 2 12.4231V13.6539"
        stroke="#16A9C9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.15388 8.11538C7.42839 8.11538 8.46158 7.0822 8.46158 5.80769C8.46158 4.53319 7.42839 3.5 6.15388 3.5C4.87938 3.5 3.84619 4.53319 3.84619 5.80769C3.84619 7.0822 4.87938 8.11538 6.15388 8.11538Z"
        stroke="#16A9C9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 13.6539V12.3958C13.9996 11.8384 13.818 11.2968 13.4839 10.8562C13.1497 10.4156 12.6819 10.1009 12.1538 9.96155"
        stroke="#16A9C9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3077 3.5C10.8358 3.6312 11.3039 3.9292 11.6382 4.34703C11.9725 4.76487 12.1539 5.27876 12.1539 5.80769C12.1539 6.33663 11.9725 6.85052 11.6382 7.26835C11.3039 7.68618 10.8358 7.98419 10.3077 8.11538"
        stroke="#16A9C9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// const timeZone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
//
// const localTimeZoneValue = format(utcToZonedTime(new Date(), timeZone), "z", {
//   timeZone,
// });
//
// const localTimeZone = localTimeZoneValue == "GMT+5:30" ? "IST" : localTimeZoneValue;

function FeatureDeepDiveIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 9.5L8 13.5L12 9.5"
        stroke="#7539D7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4.5L8 8.5L12 4.5"
        stroke="#7539D7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function EngineeringIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5152_41200)">
        <path
          d="M8 3.5V1.5"
          stroke="#616D75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 15.5V13.5"
          stroke="#616D75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 8.5L15 8.5"
          stroke="#616D75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 8.5L3 8.5"
          stroke="#616D75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5355 12.0355L12.9497 13.4497"
          stroke="#616D75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.05026 3.55026L4.46448 4.96448"
          stroke="#616D75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.46451 12.0355L3.05029 13.4497"
          stroke="#616D75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9497 3.55026L11.5355 4.96448"
          stroke="#616D75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <circle
        cx="8"
        cy="8.5"
        r="2"
        stroke="#616D75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="8"
        cy="8.5"
        r="5"
        stroke="#616D75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_5152_41200">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}

const StyledScheduleWrapper = styled(props => <Link {...props} />)`
  border: 1px solid ${COLORS.grey_20};
  border-radius: 8px;
  padding: 30px 20px;
  display: grid;
  .rightIcon {
    transition: all .3s ease-in-out;
  }
  &:hover {
    .iconHover {
      background-color: ${COLORS.grey_10};
    }
    .rightIcon {
      transform: translateX(5px);
    }
  }
  .alignSelfStart {
    align-self: start;
  }
  .displayNone {
    display: none;
  }
  .flexCenter {
    display: flex;
    align-items: center;
  }
  .iconHover {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    margin-left: 30px;
    cursor: pointer;
    &:hover {
      background-color: ${COLORS.grey_20};
    }
    svg {
      transition: all 0.3s ease-in-out;
    }
    .rotateImg {
      transform: rotate(180deg);
    }
  }
  .flexOne {
    flex: 1;
  }
  .featureList {
    ul {
      li {
        .leftIcon {
          width: auto;
          margin-top: 6px;
        }
      }
    }
  }
  .scheduleDetails {
    display: flex;
    align-items: start;
    justify-content: space-between;
    padding-bottom: 20px;
    .flexCenter {
      display: flex;
      align-items: center;
      flex: 1;
      .tagBtn {
        border-radius: 4px;
        padding: 2px 8px;
        margin-right: 10px;
        background-color: ${COLORS.grey_10};
        white-space: nowrap !important;
      }
    }
  }
  .authorWrapper {
    padding-top: 16px;
    align-self: end;
    .multipleAuthor {
      display: flex;
      align-items: end;
      padding-bottom: 20px;
      .flexOne {
        display: flex;
        align-items: center;
      }
      .flexDirectionColumn {
        flex-direction: column;
        display: flex;
        align-items: start;
        flex: 1;
        .authorImg {
          margin-left: 0;
        }
        .mb24 {
          margin-bottom: 24px;
          &:last-child {
            margin-bottom: 0px;
          }
        }
      }
      .authorImg {
        background: radial-gradient(
          154.08% 149.63% at 17.79% 40.05%,
          #5175f4 0%,
          #31e4d6 61%,
          #ffab2d 100%
        );
        border-radius: 50%;
        margin-right: 16px;
        width: 60px;
        height: 60px;
        min-width: 60px;
        min-height: 60px;
        overflow: hidden;
        img {
          width: 60px;
          min-width: 60px;
        }
      }
      .authorBigImg {
        width: 90px;
        height: 90px;
        min-width: 90px;
        min-height: 90px;
        img {
          width: 90px;
          min-width: 90px;
        }
      }
    }
  }
  ${mq.below.md} {
    min-width: 270px;
    padding: 20px;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    .iconHover {
      width: 32px;
      height: 32px;
      margin-left: 4px;
      svg {
        width: 18px;
        min-width: 18px;
      }
    }
    .scheduleDetails {
      .flexCenter {
        display: block;
        .tagBtn {
          display: inline-block;
          margin-right: 0;
          margin-bottom: 6px;
          white-space: nowrap !important;
        }
      }
    }
    .authorWrapper {
      .multipleAuthor {
        .authorImg {
          width: 40px;
          height: 40px;
          min-width: 40px;
          min-height: 40px;
          margin-right: 12px;
          img {
            width: 40px;
            min-width: 40px;
          }
        }
        .flexOne,
        .flexDirectionColumn {
          .flexCenter {
            .mpt-20 {
              padding-top: 20px;
            }
            .mobileHide {
              display: none;
            }
          }
        }
      }
    }
  }
`;

// const scrollTo = ele => {
//   document
//     .getElementById(ele)
//     .scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
// };

const IndivScheduleCard = (props) => {
  const { currentConf, keyNoteSchedule } = props;
  // const utcDate = zonedTimeToUtc(currentConf.startTime, "US/Pacific");
  //
  // const date = utcToZonedTime(utcDate.toISOString(), localTimeZone);

  // const refDate = new Date(currentConf.startTime);
  //
  // const dateValue = refDate.getDate().toString();
  //
  // const monthValue = format(refDate, "MMM");
  //
  // const timeValue = format(refDate, "h:mm a");
  //
  // const date = `${dateValue} ${monthValue} | ${timeValue} (${localTimeZone})`;

  const [currentConfIds, setCurrentConfIds] = useState({});
  // const showFullDesc = id => {
  //   const newCurrentConfIds = { ...currentConfIds };
  //   if (typeof newCurrentConfIds[id] === "undefined") {
  //     newCurrentConfIds[id] = true;
  //   } else {
  //     newCurrentConfIds[id] = !newCurrentConfIds[id];
  //     scrollTo(id);
  //   }
  //   setCurrentConfIds(newCurrentConfIds);
  // };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [props.location.pathname]);

  const getConfTypeWrapper = () => {
    if (currentConf.confType === "panel_discussion") {
      return (
        <StyledDescTag variant="cyan_60" className="tagBtn" css={flexCenter}>
          <span style={{ marginRight: "6px", marginBottom: "-4.5px" }}>
            <UsersIcon />
          </span>
          PANEL DISCUSSION
        </StyledDescTag>
      );
    }

    if (currentConf.confType === "keynote") {
      return (
        <StyledDescTag variant="green_80" className="tagBtn" css={flexCenter}>
          <Icon className="leftIcon" variant="presentation" color="green_80" size="xs" />
          KEYNOTE
        </StyledDescTag>
      );
    }

    if (currentConf.confType === "feature_deep_dive") {
      return (
        <StyledDescTag variant="purple" className="tagBtn" css={flexCenter}>
          <span style={{ marginRight: "6px", marginBottom: "-7px" }}>
            <FeatureDeepDiveIcon />
          </span>
          FEATURE DEEP DIVE
        </StyledDescTag>
      );
    }

    if (currentConf.confType === "hasura") {
      return (
        <StyledDescTag variant="grey_80" className="tagBtn" css={flexCenter}>
          <span style={{ marginRight: "6px", marginBottom: "-7px" }}>
            <EngineeringIcon />
          </span>
          ENGINEERING AT HASURA
        </StyledDescTag>
      );
    }

    if (currentConf.confType === "product_launch") {
      return (
        <StyledDescTag variant="grey_80" className="tagBtn" css={flexCenter}>
          <Icon className="leftIcon" variant="launch" color="grey_80" size="xs" />
          PRODUCT LAUNCH
        </StyledDescTag>
      );
    }

    if (currentConf.confType === "how_to") {
      return (
        <StyledDescTag variant="yellow_80" className="tagBtn" css={flexCenter}>
          <Icon className="leftIcon" variant="steps" color="yellow_80" size="xs" />
          HOW TO
        </StyledDescTag>
      );
    }

    if (currentConf.confType === "user_story") {
      return (
        <StyledDescTag variant="sky_80" className="tagBtn" css={flexCenter}>
          <Icon className="leftIcon" variant="messaging" color="sky_80" size="xs" />
          USER STORY
        </StyledDescTag>
      );
    }

    if (currentConf.confType === "workshop") {
      return (
        <StyledDescTag variant="red_80" className="tagBtn" css={flexCenter}>
          <Icon className="leftIcon" variant="code" color="red_80" size="xs" />
          WORKSHOP
        </StyledDescTag>
      );
    }

    return null;
  };

  return (
    <StyledScheduleWrapper
      to={`/events/hasura-con-2022/${currentConf.id}/`}
      id={currentConf.id}
      className="mobile-indiv-talk-card"
    >
      <div className="alignSelfStart">
        <div className="scheduleDetails">
          <div className="flexCenter">
            {getConfTypeWrapper()}
            {/*
            <StyledDesc3 variant="sky_80">
              <span style={{ textTransform: "uppercase" }}>{date}</span>
            </StyledDesc3>
            */}
          </div>
          {/*currentConf.addToCalendarLink ? (
            <a href={currentConf.addToCalendarLink} target="_blank" rel="noopener noreferrer">
              <div className="iconHover">
                <Icon variant="calendar" color="sky_80" size="md" />
              </div>
            </a>
          ) : null*/}
        </div>
        {
          keyNoteSchedule ? (
            <StyledDesc1 className="flexOne" paddingBottom="pb16" fontWeight="font_600">
              {currentConf.title}
            </StyledDesc1>
          ) : (
            <StyledDesc2 className="flexOne" paddingBottom="pb16" fontWeight="font_600">
              {currentConf.title}
            </StyledDesc2>
          )
        }
        <StyledDesc1
          className={currentConfIds[currentConf.id] ? "" : "displayNone"}
          paddingBottom="pb16"
        >
          {currentConf.desc}
        </StyledDesc1>
        {currentConf.featuresList ? (
          <div className={currentConfIds[currentConf.id] ? "" : "displayNone"}>
            {currentConf.featuresList.map((feature, index) => (
              <div key={index} className="featureList">
                <StyledDesc1 fontWeight="font_600">{feature.title}</StyledDesc1>
                <StyledDesc1 paddingBottom="pb16">
                  <ul>
                    {feature.lists.map((list, subIndex) => (
                      <li key={index + subIndex}>
                        <Icon
                          className="leftIcon"
                          variant="check_mark"
                          color="sky_80"
                          size="sm"
                        />
                        {list}
                      </li>
                    ))}
                  </ul>
                </StyledDesc1>
              </div>
            ))}
          </div>
        ) : null}
      </div>
      <div className="authorWrapper">
        <div className="multipleAuthor">
          <div className={currentConfIds[currentConf.id] ? "flexDirectionColumn" : "flexOne"}>
            {currentConf.authorDetails.map((author, index) => (
              <div
                key={index}
                className={
                  "flexCenter" +
                  (currentConfIds[currentConf.id] && currentConf.authorDetails.length > 1
                    ? " mb24"
                    : "")
                }
              >
                <div key={index} className={"authorImg " + ((keyNoteSchedule) ? "authorBigImg" : "")}>
                  <img src={author.authorImg} alt={author.name} loading="lazy" />
                </div>
                {currentConfIds[currentConf.id] || currentConf.authorDetails.length === 1 ? (
                  <StyledDesc3>
                    {author.name}
                    <br />
                    {author.designation ? (
                      <span className={currentConfIds[currentConf.id] ? "" : "mobileHide"}>
                        {author.designation}
                      </span>
                    ) : null}
                  </StyledDesc3>
                ) : null}
              </div>
            ))}
          </div>
          {/* eslint-disable-next-line */}
          {/*
          <div
            className="iconHover"
            role="button"
            tabIndex="0"
            onClick={() => showFullDesc(currentConf.id)}
          >
            <Icon
              className={currentConfIds[currentConf.id] ? "rotateImg" : ""}
              variant="chevron_down"
              color="sky_80"
              size="md"
            />
          </div>
          */}
        </div>
        <StyledDesc3 css={flexCenter}>View Recording <Icon className="rightIcon" variant="arrow_right" color="grey_100" size="sm" /></StyledDesc3>
      </div>
    </StyledScheduleWrapper>
  );
};

export default IndivScheduleCard;
